/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { SVGIcons } from "./cms/icons/svg-icons/index.js";
import { ConfirmDialog } from "./components/page-components/dialogs/confirm-dialog.jsx";

const CommunicationHub = () => {
    
    const [event, setEvent] = useState(null);
    const [open, setOpen] = useState(false);
    const origin = window.location.origin;
    
    const handleMessageFromSources = (event) => {
        console.info("received message", event);
        const isMessage = event?.type === "message";
        const isSameOrigin = event?.origin === origin;
        const data = event?.data;
        const isSimplicity = data?.owner === "simplicity";
        const isSimplicitySession = data?.type === "simplicity-session";
        if (isMessage && isSameOrigin && isSimplicity) {
            if (isSimplicitySession) {
                setEvent(data);
                setOpen(true);
            }
        }
    };
    
    const onCancel = () => {
        console.info("on cancel");
        setOpen(false);
        setEvent(null);
    };
    
    const onConfirm = () => {
        console.info("on confirm");
        setOpen(false);
        setEvent(null);
        window.location.reload();
    };
    
    useEffect(() => {
        window.addEventListener("message", handleMessageFromSources);
        return () => {
            window.removeEventListener("message", handleMessageFromSources);
        };
    }, []);

    return (
        <>
            {event &&
                <ConfirmDialog
                    className='common-dialog'
                    open={open}
                    onCancel={onCancel}
                    title={event?.title ?? "Please Note..."}
                    message={event?.message ?? "We experienced an issue. Please reload your browser now."}
                    primaryAction={onConfirm}
                    primaryButtonLabel="Reload"
                    primaryIcon={<SVGIcons.common.Reload width="20" height="20" />}
                />
            }
        </>
    );
};

export { CommunicationHub };
